import { Contact } from '../../type';
import { useChannel } from './useChannelHooks';
import { useCareTeamSelector } from './useCareTeamSelector';
import { useCallback } from 'react';
import { useDeepEqualMemo } from '@xolv-mybrightlink/common';

export const usePatientContacts = (channelGuid: string): Contact[] => {
  const channel = useChannel(channelGuid);
  const patientGuid = channel?.attributes?.patientGuid;
  const memberGuids = useDeepEqualMemo(channel?._memberGuids ?? []);
  return useCareTeamSelector(
    useCallback(
      (state) => {
        if (state === 'LOADING' || !patientGuid) {
          return [];
        }
        const contacts = state.patientContacts[patientGuid] ?? [];
        return contacts.filter((contact) => memberGuids.includes(contact.guid));
      },
      [patientGuid, memberGuids],
    ),
  );
};
